<template>
  <div>
    <div class="flex flex-col gap-1 text-flexopus-black text-sm font-medium">
      <div class="flex items-start gap-2">
        <MapIcon class="text-microsoft-blue-default w-5 h-5" />
        <h6>
          <div>{{ bookable.location?.building?.name }}</div>
          <div>{{ bookable.location?.name }}</div>
        </h6>
      </div>
      <div class="flex gap-2">
        <MapPinIcon class="text-microsoft-blue-default w-5 h-5" />
        <h6>
          {{ bookable.location?.building?.address }}
        </h6>
      </div>
      <div class="flex gap-2">
        <UserIcon class="text-microsoft-blue-default w-5 h-5" />
        <h6 v-if="!!bookable.capacity">
          {{ $tc('App.Capacity', bookable.capacity, { capacity: bookable.capacity }) }}
        </h6>
        <h6 v-else>
          {{ $t('App.NoCapacity') }}
        </h6>
      </div>
    </div>
    <div class="divider mt-3 mb-2" />
    <div class="mb-2">
      <span class="text-neutral-gray-500 text-xs font-medium mt-2">
        {{ $t('App.EquipmentAndTags') }}
      </span>
      <div
        v-if="bookable.equipments.length > 0"
        class="flex flex-wrap gap-2 text-microsoft-blue-default text-sm font-medium"
      >
        <span
          v-for="(equipment, key) in bookable.equipments"
          :key="key"
          class="bg-microsoft-azure rounded-md px-2 truncate max-w-full py-1"
        >{{ equipment }}</span>
      </div>
      <div v-else>
        <h6 class="text-flexopus-black text-sm font-medium">
          {{ $t('App.NoTags') }}
        </h6>
      </div>
    </div>
    <div class="mb-2">
      <span class="text-neutral-gray-500 text-xs font-medium mt-2">
        {{ $t('App.Description') }}
      </span>
      <h6 class="text-flexopus-black text-sm font-medium">
        {{ !bookable.description ? $t('App.NoDescription') : bookable.description }}
      </h6>
    </div>
    <div
      v-if="bookable.images.length"
      class="mb-4"
    >
      <span class="text-neutral-gray-500 text-xs font-medium mt-2">
        {{ $t('App.Images') }}
      </span>
      <ImageGallery :images="bookable.images" />
    </div>
    <div class="mb-4">
      <span class="text-neutral-gray-500 text-xs font-medium mt-2">
        {{ $t('App.Floorplan') }}
      </span>
      <location-map
        :map="bookable.location?.map_url"
        :selected="bookable.code"
        :name="bookable.name"
        :capacity="bookable.capacity"
      />
    </div>
    <div class="block">
      <button
        v-if="!isSelectedAttendee"
        class="btn btn-primary mb-3 w-full"
        @click="$emit('add')"
      >
        {{ $t('App.AddRoom') }}
      </button>
      <button
        v-else
        class="btn btn-danger mb-3 w-full"
        @click="$emit('remove')"
      >
        {{ $t('App.RemoveRoom') }}
      </button>
    </div>
  </div>
</template>

<script>
import { Map as MapIcon, MapPin as MapPinIcon, User as UserIcon } from 'lucide-vue'
import LocationMap from '@/components/LocationMap.vue'
import ImageGallery from './ImageGallery.vue'

export default {
  components: {
    LocationMap,
    MapIcon,
    MapPinIcon,
    UserIcon,
    ImageGallery,
  },
  props: {
    bookable: {
      required: true,
      type: Object,
    },
    isSelectedAttendee: {
      required: true,
      type: Boolean,
    },
  },
}
</script>
